import { normalizeStatus, type WorkflowStatus } from "@rekonas/domain";
import { cn } from "@rekonas/ui";

const styles: Record<string, string> = {
  complete: "border-emerald-200 bg-emerald-50 text-emerald-800",
  completed: "border-emerald-200 bg-emerald-50 text-emerald-800",
  ready: "border-emerald-200 bg-emerald-50 text-emerald-800",
  uploaded: "border-emerald-200 bg-emerald-50 text-emerald-800",
  failed: "border-red-200 bg-red-50 text-red-800",
  running: "border-sky-200 bg-sky-50 text-sky-800",
  processing: "border-sky-200 bg-sky-50 text-sky-800",
  uploading: "border-cyan-200 bg-cyan-50 text-cyan-800",
  queued: "border-violet-200 bg-violet-50 text-violet-800",
  paused: "border-amber-200 bg-amber-50 text-amber-800",
  pending: "border-slate-200 bg-slate-50 text-slate-600",
  created: "border-slate-200 bg-slate-50 text-slate-600",
  "not-started": "border-slate-200 bg-slate-50 text-slate-600",
};

const labels: Record<string, string> = {
  complete: "Complete",
  completed: "Complete",
  ready: "Ready",
  uploaded: "Uploaded",
  failed: "Failed",
  running: "Running",
  processing: "Processing",
  uploading: "Uploading",
  queued: "Queued",
  paused: "Paused",
  pending: "Pending",
  created: "Created",
  "not-started": "Not started",
};

export function StatusBadge({ status, pulse = false }: { status?: WorkflowStatus; pulse?: boolean }) {
  const normalized = normalizeStatus(status);
  return (
    <span
      className={cn(
        "inline-flex w-fit items-center gap-1.5 rounded-full border px-2 py-0.5 text-[11px] font-bold",
        styles[normalized] || "border-slate-200 bg-slate-50 text-slate-600",
      )}
    >
      <span
        className={cn(
          "size-1.5 rounded-full bg-current opacity-70",
          pulse && ["running", "processing", "uploading", "queued"].includes(normalized) && "animate-pulse",
        )}
        aria-hidden="true"
      />
      {labels[normalized] || normalized.replace(/-/g, " ")}
    </span>
  );
}
